import React from "react";

export type TagColor = "gray" | "blue" | "lime" | "yellow" | "red" | "orange";

export interface TagProps {
  color?: TagColor;
  className?: string;
  children: React.ReactNode;
}

const Tag: React.FC<TagProps> = ({ color = "gray", className = "", children }) => {
  const colorClasses =
    color === "gray"
      ? "border-gray-300 bg-gray-100 text-gray-600"
      : color === "blue"
        ? "border-blue-300 bg-blue-100 text-blue-600"
        : color === "lime"
          ? "border-lime-300 bg-lime-100 text-lime-600"
          : color === "yellow"
            ? "border-yellow-300 bg-yellow-100 text-yellow-600"
            : color === "red"
              ? "border-red-300 bg-red-100 text-red-600"
              : "border-orange-300 bg-orange-100 text-orange-600";
  return (
    <span
      className={`border inline-flex items-center px-2 py-0.5 rounded text-sm font-medium ${
        colorClasses
      } ${className}`}
    >
      {children}
    </span>
  );
};

export default Tag;
